import { AsyncPipe } from '@angular/common'
import { Component } from '@angular/core'
import { IonAlert } from '@ionic/angular/standalone'

import { AlertService } from './alert.service'

@Component({
	selector: 'app-alert',
	templateUrl: './alert.component.html',
	standalone: true,
	imports: [IonAlert, AsyncPipe],
})
export class AlertComponent {
	constructor(protected alertService: AlertService) {}
}
